{
  "jira-board-inline-editing-onboarding.message-templates.ok-button": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira-board-inline-editing-onboarding.message-templates.spotlight-body": [
    {
      "type": 0,
      "value": "You can now edit fields like the summary, assignee, parent and estimate. Select the fields to edit them."
    }
  ],
  "jira-board-inline-editing-onboarding.message-templates.spotlight-header": [
    {
      "type": 0,
      "value": "Edit details of the work item directly in the board"
    }
  ]
}